// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"95907d73","147":"48198676","184":"0699683b","265":"b9bee699","574":"d0221ff1","807":"a273bfee","818":"627c4457","899":"8e223d5d","900":"815301c4","996":"9ac965f5"}[chunkId] + ".chunk.js";
};